export default __webpack_public_path__ + "static/media/mint-video.8e16dbc9.jpg";